import {
  GET_PRONTO_PROVIDER_STATUS_REQUEST,
  GET_PRONTO_PROVIDER_STATUS_SUCCESS,
  GET_PRONTO_PROVIDER_STATUS_FAILURE,
  CREATE_PRONTO_PROVIDER_REQUEST,
  CREATE_PRONTO_PROVIDER_SUCCESS,
  CREATE_PRONTO_PROVIDER_FAILURE,
  GET_USER_INFO_REQUEST,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO_FAILURE,
} from "./constants";

let initialState = {
  providerStatusDetails: {},
  prontoId: "",
  message: "",
  messageType: "",
  showError: false,
  refreshLoading: false,
  loadingFailed: false,
  isUsInstallerAdmin: false,
  installer_id: "",
  installer_name: ""
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_PRONTO_PROVIDER_STATUS_REQUEST:
      return { ...state, refreshLoading: true };
    case GET_PRONTO_PROVIDER_STATUS_SUCCESS:
      return {
        ...state,
        prontoId: action.prontoId,
        providerStatusDetails: action.providerStatusDetails,
        messageType: action.messageType,
        message: action.message,
        showError: action.showError,
        refreshLoading: action.refreshLoading,
        loadingFailed: action.loadingFailed,
      };
    case GET_PRONTO_PROVIDER_STATUS_FAILURE:
      return {
        ...state,
        message: action.message,
        messageType: action.messageType,
        showError: action.showError,
        refreshLoading: action.refreshLoading,
        loadingFailed: action.loadingFailed,
      };
    case CREATE_PRONTO_PROVIDER_REQUEST:
      return { ...state, refreshLoading: action.refreshLoading };
    case CREATE_PRONTO_PROVIDER_SUCCESS:
      return {
        ...state,
        prontoId: action.prontoId,
        providerStatusDetails: action.providerStatusDetails,
        messageType: action.messageType,
        message: action.message,
        showError: action.showError,
        refreshLoading: action.refreshLoading,
      };
    case CREATE_PRONTO_PROVIDER_FAILURE:
      return {
        ...state,
        showError: action.showError,
        message:
          action.error && action.error.message
            ? action.error.message
            : "Unable to process your request. Please try after some time !",
        messageType: "error",
      };
    case GET_USER_INFO_REQUEST:
      return { ...state };
    case GET_USER_INFO_SUCCESS:
      return {
        ...state,
        isUsInstallerAdmin: action.isUsInstallerAdmin,
        installer_id: action.installer_id,
        installer_name: action.installer_name
      };
    case GET_USER_INFO_FAILURE:
      return { ...state };
    default:
      return { ...state };
  }
}

export default reducer;
